export const patch = <T>(root: T, part: Partial<T>) => Object.assign<T, Partial<T>>(root, part);
